import axios from 'axios';

if (!import.meta.env.VITE_APP_SPP_PROFILE_API_URL || !import.meta.env.VITE_APP_SPP_PROFILE_API_URL) {
  throw new Error('ABMI API Env not set: VUE_APP_ABMI_API_BASE_URL, VUE_APP_ABMI_API_KEY');
}

const abmiApiUrl = import.meta.env.VITE_APP_SPP_PROFILE_API_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});

export async function getSpeciesProfileContentBySNameDefaultCMS (scientificName, sppGroup, isSpecies) {
  // console.log(scientificName, sppGroup, isSpecies)
  const apiFct = 'spp-profile';
  const params = {
    '@ancestor': isSpecies ? `/species/${sppGroup}` : '/Habitat',
    name: scientificName
  }
  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;
    return data.results.length > 0 ? data.results[0] : {};
  } catch (error) {
    console.error(error);
  }
  return null;
}
// from API only approved one will be delivered
export async function getSpeciesProfileContentBySName (scientificName, sppGroup, isSpecies) {
  // console.log(scientificName, sppGroup, isSpecies)
  const apiFct = 'species-profile/single-profile';
  const params = {
    sname: scientificName,
    forNL: false
  }
  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

const abmiApi = {
  getSpeciesProfileContentBySName

};

export default abmiApi;
